export default {
  API_BASE_URL: process.env.VUE_APP_BASE_URL,
  API_PATH: 'api' // can be api/v1
}
